import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function PasswordResetPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    
    // Aqui você faria a chamada para a API de recuperação de senha
    // Exemplo:
    // try {
    //   await axios.post('http://localhost:8000/api/v1/auth/forgot-password', { email });
    //   setMessage('Se um email correspondente for encontrado, um link de recuperação de senha será enviado.');
    // } catch (err) {
    //   setError(err.response?.data?.detail || 'Erro ao solicitar recuperação de senha.');
    // }

    // Simulação para fins de desenvolvimento
    setMessage('Se um email correspondente for encontrado, um link de recuperação de senha será enviado.');
    console.log(`Solicitação de recuperação de senha para: ${email}`);
  };

  return (
    <div>
      <h2>Recuperar Senha</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        {message && <p style={{ color: 'green' }}>{message}</p>}
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button type="submit">Enviar Link de Recuperação</button>
      </form>
      <p>
        Lembrou da senha? <Link to="/login">Faça login</Link>
      </p>
    </div>
  );
}

export default PasswordResetPage;